// A1: fetch only the prescriptions a screen needs (by id) instead of paging the whole list.
import { apiFetch } from '@/api/client';

const CHUNK = 100; // keeps the query string well under URL length limits

export function prescriptionIdsOf(headers: unknown[]): string[] {
  const ids = new Set<string>();
  for (const h of headers) {
    const id = (h as { prescription_id?: string | null }).prescription_id;
    if (id) ids.add(id);
  }
  return [...ids];
}

export async function fetchPrescriptionsByIds<T>(ids: string[]): Promise<T[]> {
  const out: T[] = [];
  for (let i = 0; i < ids.length; i += CHUNK) {
    const chunk = ids.slice(i, i + CHUNK);
    const page = await apiFetch<{ results?: T[] } | T[]>('/api/prescriptions/', {
      query: { ids: chunk.join(','), page_size: CHUNK },
    });
    out.push(...(Array.isArray(page) ? page : (page.results ?? [])));
  }
  return out;
}
